module.exports = __webpack_public_path__ + "static/media/more.a0982912.svg";